// import React, { useEffect, useState } from "react";
// import "./JobLinksTable.css";

// const JobLinksSection = ({ jobId }) => {
//   const [job, setJob] = useState(null);

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs/${jobId}`)
//       .then((res) => res.json())
//       .then((data) => setJob(data))
//       .catch((err) => console.error("Failed to fetch job:", err));
//   }, [jobId]);

//   // Button label and class based on item label
//   const getButtonProps = (label) => {
//     const lower = label.toLowerCase();
//     if (lower.includes("apply")) return { text: "Apply", className: "btn-apply" };
//     if (lower.includes("website") || lower.includes("visit")) return { text: "Visit", className: "btn-visit" };
//     if (lower.includes("result")) return { text: "Check", className: "btn-check" };
//     return { text: "Download", className: "btn-download" };
//   };

//   const renderSection = (icon, title, items) => {
//     if (!items || items.length === 0) return null;

//     return items.map((item, index) => {
//       const { text, className } = getButtonProps(item.label);

//       return (
//         <tr key={index}>
//           {index === 0 && (
//             <td className="section-title" rowSpan={items.length}>
//               <span className="icon">{icon}</span>
//               <span className="title">{title}</span>
//             </td>
//           )}
//           <td><strong>{item.label}</strong></td>
//           <td>
//             <a
//               href={item.value}
//               target="_blank"
//               rel="noopener noreferrer"
//               className={`action-btn ${className}`}
//             >
//               {text}
//             </a>
//           </td>
//         </tr>
//       );
//     });
//   };

//   if (!job) return <div>Loading...</div>;

//   const importantLinks = [];

//   if (job.applyUrl) {
//     importantLinks.push({ label: "Apply Now", value: job.applyUrl });
//   }

//   if (job.websiteUrl) {
//     importantLinks.push({ label: "Official Website", value: job.websiteUrl });
//   }

//   return (
//     <div className="job-links-container">
//       <table className="link-table">
//         <tbody>
//           {renderSection("🔗", "Important Links", importantLinks)}
//           {renderSection("📄", "Notification PDFs", job.pdfUrl)}
//           {renderSection("🪪", "Admit Cards", job.admitCard)}
//           {renderSection("📢", "Results", job.result)}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default JobLinksSection;




// import React, { useEffect, useState } from "react";
// import "./JobLinksTable.css";

// const JobLinksSection = ({ jobId }) => {
//   const [job, setJob] = useState(null);

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs/${jobId}`)
//       .then((res) => res.json())
//       .then((data) => setJob(data))
//       .catch((err) => console.error("Failed to fetch job:", err));
//   }, [jobId]);

//   // Button label and class based on item label
//   const getButtonProps = (label) => {
//     const lower = label.toLowerCase();
//     if (lower.includes("apply")) return { text: "Apply", className: "btn-apply" };
//     if (lower.includes("website") || lower.includes("visit")) return { text: "Visit", className: "btn-visit" };
//     if (lower.includes("result")) return { text: "Check", className: "btn-check" };
//     return { text: "Download", className: "btn-download" };
//   };

//   const renderSection = (icon, title, items) => {
//     if (!items || items.length === 0) return null;

//     return items.map((item, index) => {
//       const { text, className } = getButtonProps(item.label);

//       return (
//         <tr key={index}>
//           {index === 0 && (
//             <td className="section-title" rowSpan={items.length}>
//               <span className="icon">{icon}</span>
//               <span className="title">{title}</span>
//             </td>
//           )}
//           <td><strong>{item.label}</strong></td>
//           <td>
//             <a
//               href={item.value}
//               target="_blank"
//               rel="noopener noreferrer"
//               className={`action-btn ${className}`}
//             >
//               {text}
//             </a>
//           </td>
//         </tr>
//       );
//     });
//   };

//   if (!job) return <div>Loading...</div>;

//   const importantLinks = [];

//   if (job.applyUrl) {
//     importantLinks.push({ label: "🚀 Apply Now", value: job.applyUrl });
//   }

//   if (job.websiteUrl) {
//     importantLinks.push({ label: "🌐 Official Website", value: job.websiteUrl });
//   }

//   return (
//     <div className="job-links-container">
//       <table className="link-table">
//         <tbody>
//           {renderSection("🔗", "Important Links", importantLinks)}
//           {renderSection("📄", "Notification PDFs", job.pdfUrl)}
//           {renderSection("🪪", "Admit Cards", job.admitCard)}
//           {renderSection("📢", "Results", job.result)}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default JobLinksSection;



import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // ✅ to get slug from URL
import "./JobLinksTable.css";

const JobLinksSection = () => {
  const { slug } = useParams(); // ✅ Get slug from URL
  const [job, setJob] = useState(null);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
    fetch(`${API_URL}/jobs/slug/${slug}`) // ✅ Updated endpoint
      .then((res) => res.json())
      .then((data) => setJob(data))
      .catch((err) => console.error("Failed to fetch job:", err));
  }, [slug]);

  // Helper for button label and style
  const getButtonProps = (label) => {
    const lower = label.toLowerCase();
    if (lower.includes("apply")) return { text: "Apply", className: "btn-apply" };
    if (lower.includes("website") || lower.includes("visit")) return { text: "Visit", className: "btn-visit" };
    if (lower.includes("result")) return { text: "Check", className: "btn-check" };
    return { text: "Download", className: "btn-download" };
  };

  // Section renderer
  const renderSection = (icon, title, items) => {
    if (!items || items.length === 0) return null;

    return items.map((item, index) => {
      const { text, className } = getButtonProps(item.label);

      return (
        <tr key={index}>
          {index === 0 && (
            <td className="section-title" rowSpan={items.length}>
              <span className="icon">{icon}</span>
              <span className="title">{title}</span>
            </td>
          )}
          <td><strong>{item.label}</strong></td>
          <td>
            <a
              href={item.value}
              target="_blank"
              rel="noopener noreferrer"
              className={`action-btn ${className}`}
            >
              {text}
            </a>
          </td>
        </tr>
      );
    });
  };

  if (!job) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  const importantLinks = [];

  if (job.applyUrl) {
    importantLinks.push({ label: "🚀 Apply Now", value: job.applyUrl });
  }

  if (job.websiteUrl) {
    importantLinks.push({ label: "🌐 Official Website", value: job.websiteUrl });
  }

  return (
    <div className="job-links-container">
      <table className="link-table">
        <tbody>
          {renderSection("🔗", "Important Links", importantLinks)}
          {renderSection("📄", "Notification PDFs", job.pdfUrl)}
          {renderSection("🪪", "Admit Cards", job.admitCard)}
          {renderSection("📢", "Results", job.result)}
        </tbody>
      </table>
    </div>
  );
};

export default JobLinksSection;

